import history from '../../util/history'

const dateChange = async (date, room_ids) => {
  history.push('/daily/date/' + date.toISODate(), { room_ids: room_ids })
  return true
}

export default dateChange
